import { Component, OnInit, AfterViewInit } from '@angular/core';
import * as Feather from 'feather-icons';
import { UserService } from 'src/app/services/users/user.service';
import { TransferDataService } from 'src/app/services/transfer-data/transfer-data.service';
import { empty } from 'src/app/utils/functions';




@Component({
  selector: 'app-c-meeting',
  templateUrl: './c-meeting.component.html',
  styleUrls: ['./c-meeting.component.scss']
})
export class CMeetingComponent implements OnInit, AfterViewInit {

  constructor(private userService: UserService, private transferService: TransferDataService) { }

  ngOnInit() {
    this.getUser();
  }
  ngAfterViewInit() {
    Feather.replace();
  }

  getUser() {
    this.transferService.getAuthUser().subscribe(authUser => {
      if (empty(authUser)) {
        this.userService.getCurrentUser().subscribe((user: any) => {
          this.transferService.setAuthUser(user);
        });
      }
    });
  }

}
